export default __webpack_public_path__ + "c1bb84e022ca9d76984d4b943bd678fd.svg";